export const DELEGATE_TARGET_SEARCH_VISIBILITY_THRESHOLD = 5;
export const AGENT_PROFILE_GENERIC_VALUE = '';

// Chakra's Menu popper measures placement once at open and never re-measures
// on content resize, so the shell height must stay constant across every
// step it can be open on (ROOT <-> TASK_TYPE) for that measurement to stay valid.
export const DELEGATE_MENU_FIXED_SHELL_CLASS =
  '!flex !flex-col !h-[min(520px,calc(100dvh-2rem))] overflow-hidden';
